export const AUTH_CONSTANTS = {
  ACCESS_TOKEN_EXPIRY_MINUTES: 24 * 60,
  REFRESH_TOKEN_EXPIRY_DAYS: 30,
  TOKEN_REFRESH_TIMEOUT_MS: 30000,
  TOKEN_REFRESH_INTERVAL_MINUTES: (24 * 60) - 5,
};

